import { render, staticRenderFns } from "./ModalEditarParametro.vue?vue&type=template&id=2a8763c5&scoped=true"
import script from "./ModalEditarParametro.vue?vue&type=script&lang=js"
export * from "./ModalEditarParametro.vue?vue&type=script&lang=js"
import style0 from "./ModalEditarParametro.vue?vue&type=style&index=0&id=2a8763c5&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8763c5",
  null
  
)

export default component.exports